const CHECKOUT_RECOVERY_STORAGE_PREFIX = 'sg:checkout-recovery';
const CHECKOUT_RECOVERY_TTL_MS = 24 * 60 * 60 * 1000;

type RecoveryBillingType = 'stripe' | 'manual' | 'grandfathered' | null;

function getCheckoutRecoveryStorageKey(organizationId: string) {
  return `${CHECKOUT_RECOVERY_STORAGE_PREFIX}:${organizationId}`;
}

export function markCheckoutRecoveryPending(organizationId: string, recordedAt = Date.now()) {
  localStorage.setItem(
    getCheckoutRecoveryStorageKey(organizationId),
    JSON.stringify({ recordedAt }),
  );
}

export function clearCheckoutRecoveryPending(organizationId: string) {
  localStorage.removeItem(getCheckoutRecoveryStorageKey(organizationId));
}

export function hasCheckoutRecoveryPending(organizationId: string, now = Date.now()) {
  const rawValue = localStorage.getItem(getCheckoutRecoveryStorageKey(organizationId));
  if (!rawValue) {
    return false;
  }

  try {
    const parsed = JSON.parse(rawValue) as { recordedAt?: number };
    if (typeof parsed.recordedAt !== 'number') {
      clearCheckoutRecoveryPending(organizationId);
      return false;
    }

    if (now - parsed.recordedAt > CHECKOUT_RECOVERY_TTL_MS) {
      clearCheckoutRecoveryPending(organizationId);
      return false;
    }

    return true;
  } catch {
    clearCheckoutRecoveryPending(organizationId);
    return false;
  }
}

export function shouldResumeCheckoutRecovery(
  organizationId: string | null | undefined,
  billingType: RecoveryBillingType,
  subscriptionStatus: string | null,
  now = Date.now(),
) {
  if (!organizationId) {
    return false;
  }

  return (
    billingType === 'stripe' &&
    subscriptionStatus === 'incomplete' &&
    hasCheckoutRecoveryPending(organizationId, now)
  );
}
